import { useMemo } from 'react';
import { Link as RRLink } from 'react-router-dom';
// Models
import { IUsage } from 'app/store/BillingUsage/BillingUsage.models';
// Mui
import { Link, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Theme } from '@mui/material';
// Icons
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
// Utils
import { toNumberWithCommas } from 'app/utilities/Utilities';
// 
import InvoiceNumberChips from './InvoiceNumberChips';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  data: IUsage[];
};

export default function UsageByCase({ data }: Props) {
  const { t } = useTranslation();

  const totalAmount = useMemo(() => {
    return data.reduce((acc:number, cur) => acc + cur.amount, 0)
  }, [data]);

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>{t('labels.caseName')}</TableCell>
            <TableCell sx={{ width: '50%' }}>{t('labels.invoices')}</TableCell>
            <TableCell>{t('labels.total')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((usage, index) => (
            <TableRow key={`tableRow-${usage.reference?.value}-${index}`}>
              <TableCell>
                <Link
                  sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
                  component={RRLink}
                  target="_blank"
                  to={`/admin/cases/${usage.reference?.value}/documents`}
                  underline="none"
                >
                  {usage.reference?.name}
                  <OpenInNewIcon fontSize="small" />
                </Link>
              </TableCell>
              <TableCell><InvoiceNumberChips invoices={usage.invoices || []} /></TableCell>
              <TableCell>{`$${toNumberWithCommas(usage.amount)}`}</TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter sx={{ position: 'sticky', bottom: 0, backgroundColor: 'white', zIndex: 1 }}>
          <TableRow sx={{
            bgcolor: (theme:Theme) => theme.palette.grey[50],
            '& > td': {
              borderBottom: 0
            }
          }}>
            <TableCell sx={{ fontWeight: 700, fontSize: '0.875rem' }} colSpan={2}>{t('labels.total')}</TableCell>
            <TableCell sx={{ fontWeight: 700, fontSize: '0.875rem' }}>{`$${toNumberWithCommas(totalAmount)}`}</TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}
